// extracted by mini-css-extract-plugin
export default {"FlatPreview":"FlatPreview_FlatPreview__5tfwq","safeAreaInfoBlock":"FlatPreview_safeAreaInfoBlock__9V4-7","infoIcon":"FlatPreview_infoIcon__031s7"};